var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgScarchIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 13,
    viewBox: "0 0 14 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.02184 7.36657C3.64406 7.98879 4.39962 8.2999 5.28851 8.2999C6.1774 8.2999 6.93295 7.98879 7.55518 7.36657C8.1774 6.74435 8.48851 5.98879 8.48851 5.0999C8.48851 4.21101 8.1774 3.45546 7.55518 2.83324C6.93295 2.21101 6.1774 1.8999 5.28851 1.8999C4.39962 1.8999 3.64406 2.21101 3.02184 2.83324C2.39962 3.45546 2.08851 4.21101 2.08851 5.0999C2.08851 5.98879 2.39962 6.74435 3.02184 7.36657ZM9.55518 8.2999L13.0885 11.8332L12.0218 12.8999L8.48851 9.36657V8.7999L8.28851 8.5999C7.44406 9.33324 6.44406 9.6999 5.28851 9.6999C3.99962 9.6999 2.89962 9.25546 1.98851 8.36657C1.09962 7.47768 0.655175 6.38879 0.655175 5.0999C0.655175 3.81101 1.09962 2.72212 1.98851 1.83323C2.89962 0.922124 3.99962 0.466568 5.28851 0.466568C6.5774 0.466568 7.66629 0.922124 8.55518 1.83323C9.44406 2.72212 9.88851 3.81101 9.88851 5.0999C9.88851 5.56657 9.7774 6.0999 9.55518 6.6999C9.33295 7.27768 9.0774 7.74435 8.78851 8.0999L8.98851 8.2999H9.55518Z",
    fill: "#212121"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgScarchIcon);
export default __webpack_public_path__ + "static/media/scarchIcon.dedbe30a88eb37bba21f969f1f40a5e1.svg";
export { ForwardRef as ReactComponent };